import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const hasRequiredPrivilege = (accessCode, privilegeCodes = []) => {
  if (!accessCode) {
    return true;
  }

  const requiredCodes = Array.isArray(accessCode) ? accessCode : [accessCode];
  return requiredCodes.some((code) => privilegeCodes.includes(code));
};

const PrivilegedRoute = ({ children, accessCode }) => {
  const { user } = useSelector((state) => state.auth);
  const privilegeCodes = user?.privilege?.map((p) => p.privilegeCode) || [];

  if (!hasRequiredPrivilege(accessCode, privilegeCodes)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivilegedRoute;